import React, {useEffect, useState} from "react";
import {Button, Form, Modal, Row, Space, notification} from "antd";
import {InputFields} from "components/common";
import Icon from "assets/icons";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {payService} from "api";
import moment from "moment";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {DataFormField} from "types/models/input-field-type";
import {setCallApi} from "redux/reducer/reduxCommon";
import catalogService from "api/catalog";
import dayjs from "dayjs";
import Notification from "components/common/notification/notification";

const {INPUT, SELECT, DATE, CURRENCY} = FIELD_TYPE;

const inputItems: DataFormField[] = [
  {
    type: SELECT,
    label: "Hình thức TT",
    name: "idHinhThucThanhToan",
    options: [
      {value: 0, label: "Tiền mặt"},
      {value: 1, label: "Chuyển khoản"},
      {value: 2, label: "Quẹt thẻ"},
    ],
    rules: [
      {
        required: true,
        message: "Bạn phải nhập trường bắt buộc",
      },
    ],
  },
  {
    type: CURRENCY,
    label: "Số tiền tạm ứng",
    name: "soTienTamUng",
    rules: [
      {
        required: true,
        message: "Bạn phải nhập trường bắt buộc",
      },
    ],
  },
  {
    type: INPUT,
    label: "Mã giao dịch",
    name: "maGiaoDich",
    // rules: [{
    //   required: true,
    //   message: "Bạn phải nhập trường bắt buộc"
    // }]
    // disable: true,
  },
  {
    type: INPUT,
    label: "Lý do tạm ứng",
    name: "lyDoTamUng",
    // css: {
    //   xs: 24,
    //   sm: 24,
    //   md: 24,
    //   lg: 12,
    //   xl: 12,
    // },
    // rules: [
    //   {
    //     required: true,
    //     message: "Bạn phải nhập trường bắt buộc",
    //   },
    // ],
  },

  {
    type: CURRENCY,
    label: "Số tiền báo cáo",
    name: "soTienBaoCao",
    // css: {
    //   xs: 24,
    //   sm: 24,
    //   md: 24,
    //   lg: 12,
    //   xl: 12,
    // },
    // rules: [{
    //   required: true,
    //   message: "Bạn phải nhập trường bắt buộc"
    // }]
  },
  {
    type: INPUT,
    label: "Số phiếu",
    name: "soPhieu",
    // css: {
    //   xs: 24,
    //   sm: 24,
    //   md: 24,
    //   lg: 12,
    //   xl: 12,
    // },
    //
    disable: true,
  },
  {
    type: SELECT,
    label: "Khoa NB",
    name: "khoaNguoiBenh",
    options: [
      {value: "Khu khám thường", label: "Khu khám thường"},
      {value: "Khu VIP", label: "Khu VIP"},
      {value: "Khoa khám bệnh", label: "Khoa khám bệnh"},
      {value: "Khoa mắt tổng hợp", label: "Khoa mắt tổng hợp"},
      {value: "Khoa cận lâm sàng", label: "Khoa cận lâm sàng"},
    ],
    rules: [
      {
        required: true,
        message: "Bạn phải nhập trường bắt buộc",
      },
    ],
    // defaultValue: 3,
  },
  {
    type: INPUT,
    label: "Người đề nghị",
    name: "nguoiLap",
    // rules: [{
    //   required: true,
    //   message: "Bạn phải nhập trường bắt buộc"
    // }],
    disable: true,
  },

  {
    type: DATE,
    label: "Ngày đề nghị",
    name: "ngayDeNghi",
    rules: [
      {
        required: true,
        message: "Bạn phải nhập trường bắt buộc",
      },
    ],
    optionsTime: {showTime: true, format: FORMAT_TIME.dateTime_3},
  },
];

const ModalUpdate = ({isShowModal, handleOk, handleCancel}) => {
  const [formData] = Form.useForm();
  const idLanKham = useAppSelector(state => state.reduxCommon.id);
  const id = useAppSelector(state => state.reduxCommon.id2);
  const [dataFields, setDataFields] = useState(inputItems);
  const disPath = useAppDispatch();

  useEffect(() => {
    getDetailTicket();
    getListKhuKham();
  }, [id, isShowModal]);

  // useEffect(()=>{
  //   formData.setFieldValue("ngayDeNghi", dayjs())
  // },[idLanKham, id])

  const getDetailTicket = async () => {
    try {
      const response = await payService.getDetailPrepayById(id).then(res => {
        // console.log('chi tiet phieu tam ung', res);
        const newData = {
          ...res.data.data,
          ngayDeNghi: res.data.data.ngayDeNghi
            ? dayjs(res.data.data.ngayDeNghi)
            : null,
        };
        formData.setFieldsValue(newData);
      });
    } catch (error) {
      // Notification(
      //   "error",
      //   "Đã có lỗi xảy ra khi lấy dữ liệu chi tiết tạm ứng"
      // );
      
    }
  };

  const getListKhuKham = async () => {
    try {
      const res = await catalogService.getListKhuKham();
      dataFields.find(e => e.name == "khoaNguoiBenh").options = res.map(e => {
        return {value: e.id, label: e.tenKhuKham};
      });
      setDataFields([...inputItems]);
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách khu khám");
    }
  };

  const onFinish = async value => {
    try {
      // console.log("value", value);
      let newData = await formData.validateFields();
      newData.ngayDeNghi = dayjs(newData.ngayDeNghi).format(
        FORMAT_TIME.timeDetail
      );
      newData.soTienTamUng = Number(newData.soTienTamUng);
      newData.soTienBaoCao = Number(newData.soTienBaoCao);
      newData.nguoiDeNghi = localStorage.getItem("fullName");
      newData.idLanKham = idLanKham;
      // console.log("data", newData);
      const response = await payService.updatePrepay(id, newData);
      Notification("success", "Cập nhật tạm ứng thành công");
      handleCancel();
      disPath(setCallApi());
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi cập nhật");
    }
  };

  const onFinishFail = error => {
    
  };

  return (
    <Modal
      title="Cập nhật thông tin tạm ứng"
      centered
      open={isShowModal}
      onCancel={handleCancel}
      width={1152}
      className="modal-add-prepay"
      footer=""
    >
      <div className="table-results">
        <Form
          form={formData}
          onFinish={onFinish}
          onFinishFailed={onFinishFail}
          initialValues={{remember: true}}
        >
          <Space direction="vertical" size={"middle"} style={{width: "100%"}}>
            {/* <Form.Item> */}
            <Row gutter={[16, 8]} justify={"space-between"}>
              <InputFields data={inputItems}></InputFields>
            </Row>
            {/* </Form.Item> */}
            <Row gutter={[16, 8]} justify={"end"}>
              <div>
                <Space>
                  <Button
                    key="cancel"
                    type="primary"
                    danger
                    onClick={handleCancel}
                  >
                    Huỷ bỏ
                  </Button>
                  ,{/* <Form.Item className="submit-button-modal"> */}
                  <Button
                    key="submit"
                    type="primary"
                    htmlType="submit"
                    icon={<Icon.save rev={0} />}
                  >
                    Lưu lại
                  </Button>
                  {/* </Form.Item> */}
                </Space>
              </div>
            </Row>
          </Space>
        </Form>
      </div>
    </Modal>
  );
};

export default ModalUpdate;
